import React, { useState, useEffect } from 'react';
import moment from 'moment';
import swal from 'sweetalert2';
import DatePicker from 'react-datepicker';
import TextareaAutosize from 'react-autosize-textarea';
import 'react-datepicker/dist/react-datepicker.css';
import '../../../scss/components/pages/signin-management.scss';
import AddWorkTimeInSignInShiftBlock from '../../AddWorkTimeInSignInShiftBlock';
import LeaveRecDetail from '../../LeaveRecDetail';
import SignInOutEditHistory from '../../SignInOutEditHistory';
import {GetStoreDetailRole} from '../../../const/constant';
import API from '../../../middleware/API';
import Pagination from '../../Pagination';
import { connect } from 'react-redux';

function SigningManagementToSalary() {
  const countOfPage = 10;
  const start = `${moment().add(-1, 'months').format('YYYY-MM')}-01`;
  //const start = moment().add(-8, 'days').format('YYYY-MM-DD');
  const end = moment(start).add(1, 'months').add(-1,'days').format('YYYY-MM-DD');
  const [currPage, setCurrPage] = useState(1);
  const [isAddWorkTimeOpen, setIsAddWorkTimeOpen] = useState(false);
  const [reload, doReload] = useState(false);
  const [searchStartDate, setSearchStartDate] = useState(moment(start));
  const [searchEndDate, setSearchEndDate] = useState(moment(end));
  const [staffList, setStaffList] = useState([]);
  const [editStaff, setEditStaff] = useState({
    expectedDate: moment(),
    expectedStart: moment(),
    expectedEnd: moment(),
  });
  const currentDetailRole = GetStoreDetailRole(localStorage.getItem('current_store_id'))
  
  const [isLeaveRecDetailDisplay, toggleLeaveRecDetail] = useState(false);
  const [isHistoryDisplay, toggleHistory] = useState(false);
  const [targetLeaveRec, setTargetLeaveRec] = useState({});
  const [signInOutHistory, setSignInOutHistory] = useState({});
  const [searchName, setSearchName] = useState('');
  const [historyName, setHistoryName] = useState('');
  const [department, setDepartment] = useState('all');
  const [totalDelay, setTotalDelay] = useState('0:0');
  const [totalDelayHour, setTotalDelayHour] = useState(0);
  const [sumTotalSalaryHour, setSumTotalSalaryHour] = useState(0);
  const [sumTotalSalaryMinute, setSumTotalSalaryMinute] = useState(0);
  const [eventId, setEventId] = useState(0);
  const [expectedDateToModify, setExpectedDateToModify] = useState('');

  const [totalDelayMinute, setTotalDelayMinute] = useState(0);
  const [attendance, setAttendance] = useState({ count: 0, records: [] });

  function loadData() {
    const params = {
      timeOffset: 8,
      start: searchStartDate.format('YYYY-MM-DD'),
      end: searchEndDate.format('YYYY-MM-DD'),
      page: currPage,
      pageSize: countOfPage,
      department: department
    };
    if (searchName) params.keyword = searchName;
    API.get('/Event/AttendanceSheet/Salary', {
      params,
    }).then((response) => {
      if (response) {
        setAttendance(response);
        var totalHours = 0;
        var totalMinutes = 0;
        var totalSalaryMinutes = 0;
        
        response.records.forEach((event) => {
          if(event.expectedSignInTime.length !== 0 && event.data && event.data[0]){
            let expected = event.expectedSignInTime.split(":");
            let actual = event.data[0].actualSignInTime.split(":");
            var expectedDate = new Date(0, 0, 0, expected[0], expected[1], 0);
            var actualDate = new Date(0, 0, 0, actual[0], actual[1], 0);
            if (actualDate > expectedDate){
              var diff = actualDate.getTime() - expectedDate.getTime();
              var hours = Math.floor(diff / 1000 / 60 / 60);
              diff -= hours * 1000 * 60 * 60;
              var minutes = Math.floor(diff / 1000 / 60);
              totalHours = totalHours + hours;
              totalMinutes = totalMinutes + minutes;
            }
          }

          if (event.totalSalaryTime !== null && event.totalSalaryTime !== undefined && event.totalSalaryTime !== '') {
            const salaryHourValue = parseFloat(event.totalSalaryTime);
            if (!isNaN(salaryHourValue)) {
              totalSalaryMinutes = totalSalaryMinutes + Math.round(salaryHourValue * 60);
            }
          }

        });
        totalHours = totalHours + Math.floor(totalMinutes / 60);
        totalMinutes = totalMinutes % 60;
        setTotalDelayHour(totalHours);
        setTotalDelayMinute(totalMinutes);
        setSumTotalSalaryHour(Math.floor(totalSalaryMinutes / 60));
        setSumTotalSalaryMinute(totalSalaryMinutes % 60);
      }
    });
  }

  useEffect(
    loadData,
    [currPage, department, searchName, searchStartDate, searchEndDate, reload],
  );

  function handleSearchStartDateChange(date) {
    setCurrPage(1);
    setSearchStartDate(date);
  }

  function handleOpenHistoryInformation(name, id1, id2, id3) {
    var ids = [];
    if(id1 !== 'N/A')
      ids.push(id1);
    if(id2 !== 'N/A')
      ids.push(id2);
    if(id3 !== 'N/A')
      ids.push(id3);

    API.get('ActualEvent/History?actualEventId='+ids.join(',')).then((res) => {
      if (res) {
        setHistoryName(name);
        setSignInOutHistory(res);
        toggleHistory(!isHistoryDisplay);
      }
    });
    // this.setState({
    //   historyName: name
    // }, () => {
    //   this.props.getSignInOutHistory([id1, id2, id3], this.handleToggleOpenHistoryBlock);
    // })
  }

  function handleSearchEndDateChange(date) {
    setCurrPage(1);
    setSearchEndDate(date);
  }

  function inputSearchChange(e) {
    setCurrPage(1);
    setSearchName(e.target.value);
  }

  function handleSearchButton() {
    setCurrPage(1);
  }

  function handleChangePage(page) {
    setCurrPage(page);
  }
  function deleteSignIn(id, userId) {
    const adminName = localStorage.getItem('adminName') || '';
    swal({
      type: 'error',
      html: '確定刪除排假?<br/>(此動作無法<span style="color:red">復原<span>)',
      showConfirmButton: true,
      showCloseButton: true,
      confirmButtonText: '確定',
      heightAuto: false,
    }).then((result) => {
      if (result.value !== undefined) {
        let objEvent = {
          data: {
            id: `${id}`
          }
        }
        API.delete('Event', objEvent).then((res) => {
          if (res) {
            setSearchName('');
            loadData();
          }
        });
      }
    });
  }
  function rejectSignIn(id, userId) {
    const adminName = localStorage.getItem('adminName') || '';
    swal({
      type: 'info',
      html: '確定退回重簽?',
      inputPlaceholder: '請輸入退回原因(選填)',
      input: 'text',
      showConfirmButton: true,
      showCloseButton: true,
      confirmButtonText: '確定',
      heightAuto: false,
    }).then((result) => {
      if (result.value !== undefined) {
        const data = { eventId: id,userId: userId,  status: 4, comment: result.value ? `${adminName}:${result.value}` : `${adminName}:` };
        API.post('/Event/Update', data).then((response) => {
          if (response) {
            setSearchName('');
            loadData();
          }
        });
      }
    });
  }

  function styleTime(strTime) {
    return <span style={{ color: '#dddddd' }}>{strTime}</span>;
  }

  function styleTotalWorkTime(arrTotalWorkTime) {
    const styleHightLight = {
      color: arrTotalWorkTime[0] > 9 ? 'red' : '#4A4A4A',
      fontWeight: arrTotalWorkTime[0] > 9 ? '900' : '400',
      fontSize: arrTotalWorkTime[0] > 9 ? '20px' : '18px',
    };
    const strHour = arrTotalWorkTime[0] < 10
      ? `0${arrTotalWorkTime[0]}`
      : arrTotalWorkTime[0];
    const strMinutes = arrTotalWorkTime[1] < 10
      ? `0${arrTotalWorkTime[1]}`
      : arrTotalWorkTime[1];

    return (
      <span style={styleHightLight}>
        {`${strHour}:${strMinutes}`}
      </span>
    );
  }

  function handleToggleOpenAddWorkTimeBlock(item) {

    if(item.resourceId === 8 || item.resourceId === 9)
      return;

    var staff = [];
    staff.push(
      {
        realName:item.name,
        expectedDate:item.expectedDate,
        expectedStart:item.expectedSignInTime.length === 0 ? '無':item.expectedSignInTime,
        expectedEnd:item.expectedSignOutTime.length === 0 ? '無':item.expectedSignOutTime,
        
      }
    )
    let newEditHoliday = {
      expectedDate:item.expectedDate,
      expectedStart:item.expectedSignInTime.length === 0 ? '無':item.expectedSignInTime,
      expectedEnd:item.expectedSignOutTime.length === 0 ? '無':item.expectedSignOutTime,
    };
    setEditStaff(
      newEditHoliday
    );

    setStaffList(staff)
    setEventId(item.eventId)
    setExpectedDateToModify(item.expectedDate)
    setIsAddWorkTimeOpen(true)
  }

  function handleAddStaffWorkRecord(item) {
    let request = {
      id : eventId,
      start: expectedDateToModify + ' ' + item.start.split(' ')[1],
      end: expectedDateToModify + ' ' + item.end.split(' ')[1],
      resourceId : item.resourceId
    }
    API.patch('/Event',request).then((response) => {
      doReload(!reload);
    });
  }

  function getRowStyle({ isSign, data }, arrTotalWorkTime) {
    const objStyle = {};
    const reducer = (final, now) => (final
      && now.actualSignInTime !== null
      && now.actualSignOutTime !== null);

    const buckyreducer = (final, now) => (final
      && now.actualSignInTime !== ''
      && now.actualSignOutTime !== '');
    if (isSign) {
      objStyle.backgroundColor = '#FA8072';
    } else if (arrTotalWorkTime[0] > 9) {
      objStyle.backgroundColor = '#fac472';
    } else if (!data.reduce(reducer, true)) {
      objStyle.backgroundColor = '#fac472';
    } else if (!data.reduce(buckyreducer, true)) {
      objStyle.backgroundColor = '#fac472';
    }
    return objStyle;
  }
  function calculateTotalWorkTime (totalWorkTime){
    var hourMinuteArr = Math.trunc(totalWorkTime);
    var decimals = totalWorkTime % 1;
    var newMinute = 0
    if(decimals < 1 && decimals >= 0.5)
      newMinute = 5;
    //return totalWorkTime;
    return `${hourMinuteArr}.${newMinute}`;
  }

  const strNoDate = 'N/A';
  const { count, records } = attendance;
  const totalPage = Math.ceil(count / countOfPage);
  const newRecords = records.map((item) => {
    console.log(item.eventId)
    const arrTotalWorkTime = item.totalWorkTime.split(':');
    console.log(item.totalWorkTime)

    const newItem = {
      ...item,
      firstSignId: item.data[0] ? item.data[0].id : strNoDate,
      firstSignInTime: item.data[0] ? item.data[0].actualSignInTime : styleTime(strNoDate),
      firstSignOutTime: item.data[0] ? item.data[0].actualSignOutTime : styleTime(strNoDate),

      secondSignId: item.data[1] ? item.data[1].id : strNoDate,
      secondSignInTime: item.data[1] ? item.data[1].actualSignInTime : styleTime(strNoDate),
      secondSignOutTime: item.data[1] ? item.data[1].actualSignOutTime : styleTime(strNoDate),

      thirdSignId: item.data[2] ? item.data[2].id : strNoDate,
      thirdSignInTime: item.data[2] && item.data[2].actualSignInTime !== '' ? item.data[2].actualSignInTime : styleTime(strNoDate),
      thirdSignOutTime: item.data[2]  && item.data[2].actualSignOutTime !== ''? item.data[2].actualSignOutTime : styleTime(strNoDate),
      totalWorkTime: styleTotalWorkTime(arrTotalWorkTime),
      totalWorkHour: calculateTotalWorkTime(item.totalWorkHour),
      totalSalaryHour: item.totalSalaryTime,
      totalWorkTimeNew: item.totalWorkTime,
      rowStyle: getRowStyle(item, arrTotalWorkTime),
    };
    return newItem;
  });

  const wholeTime = (a, b, c) => {
    let parta = [];
    let partb = [];
    let partc = [];
    let hourTotal = 0;
    let minTotal = 0;
    if(a){
      parta = a.split(":");
    }
    if(b){
      partb = b.split(":");
    }
    if(c){
      partc = c.split(":");
    }
    
    if(parta.length > 1 && partb.length > 1)
    {
      minTotal = parseInt(parta[1]) + parseInt(partb[1]);
      if (minTotal >= 60){
        hourTotal =  parseInt(minTotal / 60) ;
        minTotal = minTotal % 60;
      }
      hourTotal = hourTotal + parseInt(parta[0]) + parseInt(partb[0]);
      if(partc.length > 1){
        minTotal = minTotal + parseInt(partc[1]);

        if (minTotal >= 60){
          hourTotal = hourTotal + parseInt(minTotal / 60) ;
          minTotal = minTotal % 60;
        }
        hourTotal = hourTotal + parseInt(partc[0]);

      }
    }

    // If using time pickers with 24 hours format, add the below line get exact hours
    // if (hours < 0)
    //    hours = hours + 24;

    return (hourTotal <= 9 ? "0" : "") + hourTotal + ":" + (minTotal <= 9 ? "0" : "") + minTotal;
  }

  const diff = (id, start, end) => { 
    start = start.split(':');
    end = end.split(':');
    var startDate = new Date(0, 0, 0, start[0], start[1], 0);
    var endDate = new Date(0, 0, 0, end[0], end[1], 0);
    var diff = endDate.getTime() - startDate.getTime();
    var hours = Math.floor(diff / 1000 / 60 / 60);
    diff -= hours * 1000 * 60 * 60;
    var minutes = Math.floor(diff / 1000 / 60);

    // If using time pickers with 24 hours format, add the below line get exact hours

    return (hours <= 9 ? "0" : "") + hours + ":" + (minutes <= 9 ? "0" : "") + minutes;
  }

  const delay = (expected, actual, all) =>{
    expected = expected.split(":");
    actual = actual.split(":");
    var expectedDate = new Date(0, 0, 0, expected[0], expected[1], 0);
    var actualDate = new Date(0, 0, 0, actual[0], actual[1], 0);
    if (actualDate <= expectedDate){
      return "0"
    }
    var diff = actualDate.getTime() - expectedDate.getTime();
    var hours = Math.floor(diff / 1000 / 60 / 60);
    diff -= hours * 1000 * 60 * 60;
    var minutes = Math.floor(diff / 1000 / 60);
    if (hours < 0)
    hours = hours + 24;
    return (<span style={{color:'red'}}>{(hours <= 9 ? "0" : "") + hours + ":" + (minutes <= 9 ? "0" : "") + minutes}</span>);

  }
  const checkDelay = (expected, actual, all) =>{
    expected = expected.split(":");
    actual = actual.split(":");
    var expectedDate = new Date(0, 0, 0, expected[0], expected[1], 0);
    var actualDate = new Date(0, 0, 0, actual[0], actual[1], 0);
    if (actualDate <= expectedDate){
      return "0"
    }
    var diff = actualDate.getTime() - expectedDate.getTime();
    var hours = Math.floor(diff / 1000 / 60 / 60);
    diff -= hours * 1000 * 60 * 60;
    var minutes = Math.floor(diff / 1000 / 60);
    if (hours < 0)
    hours = hours + 24;
    return {hours, minutes}

  }
  const totalTime = (item) =>{
    console.log(item.totalWorkTimeNew);
    var totalTime = '';
    var delayTime = {};

    if(item.expectedSignInTime.length !== 0 && typeof  item.firstSignInTime === 'string')
      delayTime = checkDelay(item.expectedSignInTime,item.firstSignInTime);

    if(item.expectedSignInTime.length === 0){
      totalTime = styleTime(strNoDate);
    } else if(typeof item.thirdSignInTime !== 'string' &&  typeof item.secondSignOutTime !== 'string' && typeof item.firstSignOutTime === 'string'){
      totalTime = diff(item.eventId, item.expectedSignInTime, item.firstSignOutTime);
    }else if(typeof item.thirdSignInTime !== 'string'&& typeof item.firstSignOutTime === 'string'){
      totalTime = wholeTime(
        diff(item.eventId, item.expectedSignInTime, item.firstSignOutTime),
        diff(item.eventId, item.secondSignInTime, item.expectedSignOutTime)
        );
    }else if(typeof item.thirdSignOutTime === 'string'&& typeof item.firstSignOutTime === 'string'){
      totalTime = wholeTime(
        diff(item.eventId, item.expectedSignInTime, item.firstSignOutTime),
        diff(item.eventId, item.secondSignInTime, item.secondSignOutTime),
        diff(item.eventId, item.thirdSignInTime, item.expectedSignOutTime)
        );
    }else{
      totalTime = styleTime(strNoDate);
    }
    if(delayTime.hours || delayTime.minutes)
    {
      var finalHour = parseInt(totalTime.split(':')[0], 10)  - delayTime.hours;
      var finalMinute = (parseInt(totalTime.split(':')[1], 10) - delayTime.minutes );
      if(finalMinute < 0){
        finalMinute = finalMinute + 60;
        finalHour= finalHour - 1;
      }
      totalTime = `${(finalHour <= 9 ? "0" : "")}${finalHour}:${finalMinute}`
    }
    return totalTime;
  }
  function leaveRecBtn(leaveRec){
    return (<button
      key={leaveRec.id}
      style={{width:'70px',height:'30px'}}
      type="button"
      className={`btn btn-md m-l-16 m-r-16 ${leaveRec.status === '1' ? "success" : "slide-bar-font-color-active"}`}
      onClick={() => {
        toggleLeaveRecDetailDisplay(
          leaveRec,
        );
      }}
    >
      <span>假單</span>
    </button>);
  }
  function toggleLeaveRecDetailDisplay(leaveRec) {
    if (isLeaveRecDetailDisplay){
      setTargetLeaveRec({});
    }else{
      setTargetLeaveRec(leaveRec);
    }
    toggleLeaveRecDetail(!isLeaveRecDetailDisplay)
  }

  return (
    
    <div className="p-signInManagement">

      <div className="u-block">
        <div className="u-title">核薪專用總簽到表</div>

        <div className="sign-notice">
          <div className="u-notice">*溫馨提醒: </div>
          <div className="u-notice">1.總工時算法為(預期簽到~第一段簽退) 加上 (第二段簽到~預期簽退)</div>
          <div className="u-notice">2.算薪總小時為 總打卡時間 減去 休息時間 再調整尾數至0或0.5</div>
          <div className="u-notice">3.休息時間算法</div>
          <div className="u-notice">(1)4 ＜ 總工時 ＜ 8，休息半小時</div>
          <div className="u-notice">(2)8 ＜＝  總工時 ＜ 12，休息一小時</div>
          <div className="u-notice">(3)12 ＜＝  總工時，休息兩小時</div>
          <div className="u-notice">4.連點 預期簽到 / 預期簽退 兩次，可以進行編輯。</div>
        </div>
        <div className="u-search-box">
        <span>總遲到時間:{totalDelayHour}小時{totalDelayMinute}分</span>
        <span className="m-l-16">總算薪時間:{sumTotalSalaryHour}小時{sumTotalSalaryMinute}分</span>

          <div className="u-search-box_left">
            <div className="date-input">
              <span className="mobile-hide" style={{ flex: '0 0 20px' }}>時間：</span>
              <DatePicker
                id="date_picker_searchStartDate"
                locale="zh-tw"
                placeholderText="請選擇日期"
                dateFormat="YYYY-MM-DD"
                selected={searchStartDate}
                autoComplete="off"
                onChange={handleSearchStartDateChange}
                className="u-form__input mobile-hide"
                startDate={searchStartDate}
                endDate={searchEndDate}
              />
              <button
                type="button"
                className="btn datepickinput desktop--hide"
                onClick={(e) => {
                  e.preventDefault();
                  document.getElementById('date_picker_searchStartDate').click();
                }}
              >
                {searchStartDate.format('l')}
              </button>
            </div>
            <div className="date-input">
              <span className="mobile-hide" style={{ flex: '0 0 20px' }}>到：</span>
              <DatePicker
                id="date_picker_searchEndDate"
                locale="zh-tw"
                placeholderText="請選擇日期"
                dateFormat="YYYY-MM-DD"
                selected={searchEndDate}
                autoComplete="off"
                onChange={handleSearchEndDateChange}
                className="u-form__input mobile-hide"
                startDate={searchStartDate}
                endDate={searchEndDate}
              />
              <button
                type="button"
                className="btn datepickinput desktop--hide"
                onClick={(e) => {
                  e.preventDefault();
                  document.getElementById('date_picker_searchEndDate').click();
                }}
              >
                {searchEndDate.format('l')}
              </button>
            </div>
          </div>
          {
            currentDetailRole === '11' || currentDetailRole === '8' ?
            '':          <div className="u-search-box_right">
          <div className="date-input">
          <span className="mobile-hide"style={{ flex: '0 0 0px' }}>部門：</span>

            <select style={{minWidth:"56px"}} value={department} onChange={(e)=>{setDepartment(e.target.value)}} className="u-form__select">
            <option value="all">全部</option>
            <option value="infield">內場</option>
            <option value="outfield">外場</option>
            <option value="bar">吧檯</option>
            <option value="admin">行政</option>
            </select>
          </div>
          </div>
          }


          <div className="u-search-box_right">
            <div className="date-input" style={{width:"130px"}}>
              <input
                className="u-form__input"
                value={searchName}
                placeholder="請輸入姓名"
                onChange={inputSearchChange}
                onKeyPress={(event) => {
                  if (event.key === 'Enter') {
                    handleSearchButton();
                  }
                }}
              />
            </div>
            {/* <button
              type="button"
              className="btn btn-md save m-l-8"
              onClick={handleSearchButton}
            >
              <span>查詢</span>
            </button> */}
          </div>
        </div>
        <div className="u-table-responsive">
          <table className="u-table u-table-border u-table-striped" id="myTable">
            <thead>
              <tr>
                <th>姓名</th>
                <th>預計上班日</th>
                <th>預期簽到</th>
                <th>預期簽退</th>
                <th>簽到一</th>
                <th>簽退一</th>
                <th>簽到二</th>
                <th>簽退二</th>
                <th>簽到三</th>
                <th>簽退三</th>
                <th>遲到</th>
                <th>總工時</th>
                <th>算薪總小時</th>
                <th>簽核人</th>
                <th>簽核結果</th>
                <th>備註</th>
                <th>假單</th>
                <th>加班單</th>
                <th>異常</th>
                <th>查看紀錄</th>
              </tr>
            </thead>
            <tbody>
              {
                newRecords.map((item, index) => (
                  <tr key={index} style={item.rowStyle}>
                    <td>{item.name}</td>
                    <td>{item.expectedDate}</td>
                    <td style={{ color: item.expectedSignInTime.length === 0 ? 'red' : '' }} onDoubleClick={()=>{handleToggleOpenAddWorkTimeBlock(item)} }>{item.expectedSignInTime.length === 0 ? '無':item.expectedSignInTime}</td>
                    <td style={{ color: item.expectedSignOutTime.length === 0 ? 'red' : '' }} onDoubleClick={()=>{handleToggleOpenAddWorkTimeBlock(item)} }>{item.expectedSignOutTime.length === 0 ?'無':item.expectedSignOutTime}</td>
                    <td>{item.firstSignInTime}</td>
                    <td>{item.firstSignOutTime}</td>
                    <td>{item.secondSignInTime}</td>
                    <td>{item.secondSignOutTime}</td>
                    <td>{item.thirdSignInTime}</td>
                    <td>{item.thirdSignOutTime}</td>
                    <td>{item.expectedSignInTime.length === 0 || typeof item.firstSignInTime !== 'string' ? styleTime(strNoDate): delay(item.expectedSignInTime, item.firstSignInTime, item)}</td>
                    <td>{item.totalWorkTimeNew?styleTotalWorkTime(item.totalWorkTimeNew.split(':')):'無資料'}</td>
                    <td>{item.totalSalaryHour} 小時</td>
                    <td>{item.signName}</td>
                    <td>{item.signResult}</td>
                    <td>{item.comment}</td>
                    <td>
                    {
                      item.leaveData.length > 0 ? 
                      item.leaveData.map(leaveRecBtn,this)
                        :
                        ''
                    }
                    </td>
                    <td>
                    {item.overTimeData.length>0?
                            <button className="btn success btn-md m-l-16" onClick={() => { 
                                var overtimeData = item.overTimeData[0];
                                var payStr = overtimeData.payType === 1 ? '補休'+overtimeData.compensatoryHours+'小時':
                                overtimeData.payType === 2 ?'加班費'+overtimeData.amt+'元':
                                overtimeData.payType === 3 ?'休假日加班費'+overtimeData.amt+'元':
                                overtimeData.payType === 5 ?'國定假日'+overtimeData.amt+'元' + '補休'+overtimeData.compensatoryHours+'小時'
                                :'國定假日'+overtimeData.amt+'元';
                                swal({
                                type: 'info',
                                title: '加班單',
                                html: `
                                  <div>
                                  <p>${payStr}</p>
                                  <p>加班時數: ${overtimeData.overtimeHours} 小時</p>
                                  <p>原因: ${overtimeData.reason || '無'}</p>
                                  </div>
                                `,
                                showConfirmButton: false,
                                showCloseButton: true,
                                heightAuto: false,
                                width: '250px'
                                });
                            } }>查看</button>
                    
                            :''
}
                    </td>
                    <td className="text-align-left">
                      {
                        item.resourceId === 8 ||  item.resourceId === 9 ||  item.resourceId === 10 ?
                        <button
                        type="button"
                        className="btn delete btn-sm m-l-16"
                        onClick={() => {
                          deleteSignIn(item.eventId, item.id);
                        }}
                      >
                        <span>刪除</span>
                      </button>
                        :
                        <button
                        type="button"
                        className="btn main-color btn-sm m-l-16"
                        onClick={() => {
                          rejectSignIn(item.eventId, item.id);
                        }}
                      >
                        <span>退回</span>
                      </button>
                      }
                      
                    </td>
                    <td>
                      {
                        isNaN(item.firstSignId) ?
                        '':
                        <button className="btn main-color btn-md m-l-8" onClick={() => { handleOpenHistoryInformation(item.name ,item.firstSignId, item.secondSignId, item.thirdSignId); } }>查看</button>
                        

                      }

                    </td>
                  </tr>
                ))
              }
            </tbody>
          </table>
        </div>
        <div className="pagination-box">
          <Pagination
            currPage={currPage}
            totalPage={totalPage}
            onChangPage={handleChangePage}
          />
        </div>

      </div>
      <LeaveRecDetail 
            leaveRec={targetLeaveRec}
            isShow={isLeaveRecDetailDisplay}
            toggleFunc={toggleLeaveRecDetailDisplay}
          />
      <AddWorkTimeInSignInShiftBlock 
          isSalaryEdit={true}
          isVisible={isAddWorkTimeOpen} 
          toggleOpen={()=>{setIsAddWorkTimeOpen(false)}} 
          allStaff={staffList} 
          editStaff={editStaff}
          saveWorkRecordFunc={handleAddStaffWorkRecord}
        />
        <SignInOutEditHistory 
          isVisible={isHistoryDisplay} 
          toggleOpen={toggleHistory} 
          record={signInOutHistory}
          historyName={historyName}
        />
    </div>
  );
}

export default SigningManagementToSalary;
